import AccountBankSettingsForm from "../../components/Settings/AccountBankForm";
import NavSettings from "../../components/common/NavSettings";

const AccountBankSettings = () => {
  return (
    <>
      <NavSettings title="Mi perfil" route="Inicio" active="Perfil" />

      <AccountBankSettingsForm />
    </>
  );
};

export default AccountBankSettings;
